import React from 'react';

export const AudioPlayer = ({ src }: { src: string }) => (
  <audio src={src} controls className="w-full" />
);
